import { COUNTRIES, ECountry } from '@constants';
import { Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DescriptionWrapper, Wrapper } from './CountrySelector.styles';

type Props = {
  value?: ECountry | ECountry[];
  onChange?: (value: ECountry | ECountry[]) => void;
  allowClear?: boolean;
  mode?: 'multiple';
  disabled?: boolean;
  disableDescription?: boolean;
  placeholder?: string;
};

export const CountrySelector: React.FC<Props> = ({
  value,
  onChange,
  allowClear = false,
  mode,
  disabled = false,
  disableDescription = false,
  placeholder
}) => {
  const { t } = useTranslation('DefaultTranslations');
  const options = useMemo(
    () =>
      COUNTRIES.map(country => ({
        label: t(country),
        value: country
      })).sort((a, b) => a.label.localeCompare(b.label)),
    []
  );

  return (
    <Wrapper>
      {!disableDescription && <DescriptionWrapper>{t('THIS_DATA_IS_PRIVATE')}</DescriptionWrapper>}
      <Select
        mode={mode}
        showSearch
        value={value}
        options={options}
        onChange={onChange}
        allowClear={allowClear}
        placeholder={placeholder || t('CHOOSE_AN_OPTION')}
        style={{ minWidth: '200px' }}
        disabled={disabled}
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
      />
    </Wrapper>
  );
};
